// TODO: duplicated base colour definitions.
// We could probably user https://amzn.github.io/style-dictionary/ and define everything there.
const LMG_BLUE = '#0054A6';
// const LMG_YELLOW = '#FFDD00'; // never read here
const LMG_RED = '#ED1A3B';
const LMG_BLACK = '#000000';
const LMG_WHITE = '#FFFFFF';
const LMG_LIGHT_GREY = 'lightgrey';
const LMG_PLACEHOLDER_GREY = '#B8B8B8';

const THIRSTY_CAMEL_GREEN = '#A0CE66';
const THIRSTY_CAMEL_GREEN_HIGHLIGHT = '#7AC142';
const THIRSTY_CAMEL_RED = '#b53641';
// const THIRSTY_CAMEL_GREEN_WELLCOM = '#ACCA57';

const PRIMARY_COLOUR = THIRSTY_CAMEL_GREEN;
const SECONDARY_COLOUR = THIRSTY_CAMEL_RED;
const HIGHLIGHT_COLOUR = LMG_RED;

const theme = {
  colour: {
    general: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
      highlight: HIGHLIGHT_COLOUR,
    },
    uiControls: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
    },
    text: {
      heading: {
        primary: LMG_BLACK,
      },
      content: {
        primary: LMG_BLACK,
      },
      link: {
        primary: LMG_BLUE,
      },
      menu: {
        primary: LMG_WHITE,
      },
      form: {
        textInput: {
          primary: LMG_BLACK,
          placeholder: LMG_PLACEHOLDER_GREY,
        },
      },
      drawer: {
        primary: LMG_BLACK,
      },
      button: {
        attention: THIRSTY_CAMEL_RED,
      },
      hero: {
        header: LMG_WHITE,
      },
      tabIcons: {
        cart: {
          priceBadge: LMG_WHITE,
        },
      },
    },
    border: {
      general: {
        primary: PRIMARY_COLOUR,
      },
      appRoot: {
        primary: LMG_BLUE,
      },
    },
    icon: {
      general: {
        primary: PRIMARY_COLOUR,
        secondary: SECONDARY_COLOUR,
      },
      header: {
        primary: LMG_WHITE,
      },
    },
    background: {
      general: {
        primary: PRIMARY_COLOUR,
        secondary: SECONDARY_COLOUR,
      },
      button: {
        primary: PRIMARY_COLOUR,
        disabled: LMG_LIGHT_GREY,
      },
      hero: {
        header: THIRSTY_CAMEL_RED,
      },
      drawer: THIRSTY_CAMEL_GREEN_HIGHLIGHT,
      feedTile: {
        promotion: THIRSTY_CAMEL_GREEN,
      },
      range: {
        tileContainer: THIRSTY_CAMEL_GREEN_HIGHLIGHT,
      },
    },
    activityIndicator: {
      primary: PRIMARY_COLOUR,
    },
    checkbox: {
      primary: THIRSTY_CAMEL_RED,
    },
  },
  size: {
    text: {
      body1: 18,
      body2: 16,
      heading0: 24,
      heading1: 20,
      heading2: 18,
      heading3: 16,
      heading4: 14,
      caption: 14,
    },
  },
};

export default theme;
